export default __webpack_public_path__ + "static/media/moltensteelslash5.e46192a6.png";